// extracted by mini-css-extract-plugin
export default {"wrap":"kq-z","logoContainer":"lq-z","brandImg":"mq-z","logoImg":"nq-z","logoButton":"oq-z"};